import 'core-js/stable'
import 'regenerator-runtime/runtime'
import PublicServicesMap from '../com/public_services_map'
import PublicServicesMapDetail from '../com/public_service_map_detail'
import PublicCompanyMap from '../com/public_company_map'
import mountComponents from '../src/mount_react'

mountComponents({ PublicServicesMap, PublicServicesMapDetail, PublicCompanyMap })
